import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BASE_URL, IMAGE_URL } from '../../../config/axios';
import { handleErrorToast } from '../../CustomFunctions';
import { ToastContainer, toast } from 'react-toastify';

const Careernavbar = ({ id }) => {

  const [jobposition, setJobPosition] = useState({})


  const getJobpositionlist = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/jd/jobpost/${id}/`);
      setJobPosition(res.data)
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      toast.error(message);
      // handleErrorToast(err);
    }
  };

  useEffect(() => {
    getJobpositionlist();
  }, []);

  return (
    <>
      <div className='career-navbar'>
        <div>
          {/* <img className="sidebar-expanded-logo" src="https://g-eng.s3.ap-south-1.amazonaws.com/template-img/%60logo.png" alt="logo" /> */}
          <img
            className="sidebar-expanded-logo"
            src={
              jobposition?.sub_company_logo
                ? `${IMAGE_URL}${jobposition?.sub_company_logo}`
                : "https://g-eng.s3.ap-south-1.amazonaws.com/template-img/%60logo.png"
            }
            alt="company-logo"
          />
        </div>
        <div>
          <span className='font-size-subheading'>{jobposition.department_name}</span><br />
          <span className='font-size-heading'>{jobposition.position_name}</span><br />
          <span className='font-size-subheading'>{jobposition.location}</span>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

    </>
  )
}

export default Careernavbar
